import { h } from "preact";

function ImageNestedSectionsOnboarding() {
    return (
        <svg width="134" height="102" viewBox="0 0 134 102" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity=".6" x="16" y="4" width="35" height="6" rx="1" fill="var(--label-tertiary)"/>
            <rect opacity=".6" x="32" y="56" width="19" height="6" rx="1" fill="var(--label-tertiary)"/>
            <rect y="102" width="102" height="4" rx="2" transform="rotate(-90 0 102)" fill="var(--control-accent)"/>
            <rect x="16" y="102" width="50" height="4" rx="2" transform="rotate(-90 16 102)" fill="var(--control-accent)"/>
            <mask id="bi7zy5mn1a" fill="var(--editor-white)">
                <rect x="16" y="16" width="40" height="30" rx="1"/>
            </mask>
            <rect x="16" y="16" width="40" height="30" rx="1" fill="var(--background-secondary)" stroke="var(--border-tertiary)" stroke-width="4" mask="url(#bi7zy5mn1a)"/>
            <mask id="ez420r5r8b" fill="var(--editor-white)">
                <rect x="32" y="68" width="40" height="30" rx="1"/>
            </mask>
            <rect x="32" y="68" width="40" height="30" rx="1" fill="var(--background-secondary)" stroke="var(--border-tertiary)" stroke-width="4" mask="url(#ez420r5r8b)"/>
            <mask id="kuc44ihoxc" fill="var(--editor-white)">
                <rect x="62" y="16" width="40" height="30" rx="1"/>
            </mask>
            <rect x="62" y="16" width="40" height="30" rx="1" fill="var(--background-secondary)" stroke="var(--border-tertiary)" stroke-width="4" mask="url(#kuc44ihoxc)"/>
            <mask id="3jqfw6jh3d" fill="var(--editor-white)">
                <rect x="78" y="68" width="40" height="30" rx="1"/>
            </mask>
            <rect x="78" y="68" width="40" height="30" rx="1" fill="var(--background-secondary)" stroke="var(--border-tertiary)" stroke-width="4" mask="url(#3jqfw6jh3d)"/>
        </svg>
    );
}

export default ImageNestedSectionsOnboarding;
